import React, { useMemo } from 'react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { StepperFromProps } from 'sharedComponents/dynamicStepperForm/dynamicStepperFormInterface';
import { RootState } from 'store/store';
import { BLACK_BOOK_QUESTIONS_V2, transformSingleChoiceData } from '../TradeInConstant';
import { displayKeyPointers, formatWithCommaSeparator, transformQuestions } from '../TradeInUtils';
import CircleArrow from './images/circle-arrow.png';
import Headphone from './images/headphone-image.png';

const Result: React.ForwardRefRenderFunction<unknown, StepperFromProps> = () => {
  const { t } = useTranslation();

  const { getValues } = useFormContext();

  const vehicleHeading = getValues('heading');
  const mileage = getValues('mileage');

  const { authenticateClientData } = useSelector((state: RootState) => state.auth);

  const { offerValue } = useSelector((state: RootState) => state.commonModuleStore);

  const showChatOption = authenticateClientData?.data?.widgetData?.showChat ?? false;

  const singleChoice = transformSingleChoiceData(transformQuestions(BLACK_BOOK_QUESTIONS_V2()), getValues(), t);

  const filteredPointers = useMemo(() => {
    const keyPointers = displayKeyPointers(singleChoice, BLACK_BOOK_QUESTIONS_V2()).filter(
      (pointer) => pointer?.keyTxt
    );

    return {
      nonYes: keyPointers.filter((pointer) => pointer?.actualAnsTxt !== 'Yes'),
      yes: keyPointers.filter((pointer) => pointer?.actualAnsTxt === 'Yes'),
    };
  }, [singleChoice]);

  const optimyWidget = () => {
    const eventDataObj = {
      vendor: 'dabadu',
      item_year: getValues('year'),
      item_make: getValues('make'),
      item_model: getValues('model'),
      first_name: getValues('firstName'),
      last_name: getValues('lastName'),
      phone: getValues('phone'),
      email: getValues('email'),
    };
    const messageData = {
      type: 'iframeFormSubmitted',
      formName: 'Trade In',
      eventDataObj: eventDataObj,
    };

    window.parent.postMessage(messageData, '*');
  };

  return (
    <>
      <div className='result-page-wrapper'>
        {offerValue?.Valued ? (
          <>
            <div className='result-page-heading'>{t('stepperFormTradeIn.YourOfferIsReady')}</div>
            <div className='result-page-para'>{t('stepperFormTradeIn.txt1')}</div>
          </>
        ) : null}

        <div className='result-box d-flex align-items-center'>
          {/* <div className='result-box__left'>
            <img src={CarImage} alt='car' />
          </div> */}
          <div className='result-box__right'>
            {vehicleHeading ? (
              <div className='car-name'>{`${vehicleHeading} at ${formatWithCommaSeparator?.(mileage)} km`}</div>
            ) : null}
          </div>
        </div>

        <div className='offline-box'>
          <div className='offline-text'>{t('stepperFormTradeIn.txt4')}</div>
          <div className='offline-value'>
            {offerValue?.Valued ? `$${formatWithCommaSeparator(offerValue?.Value)}` : 'Unavailable'}
          </div>
        </div>

        {showChatOption && showChatOption?.toUpperCase() == 'TRUE' ? (
          <div className='happens-next-wrapper d-flex align-items-center'>
            <div className='happens-next-text'>{t('stepperFormTradeIn.txt2')}</div>
            <button type='button' className='btn-support-team' onClick={optimyWidget}>
              <div className='support-team-wrapper d-flex'>
                <img src={Headphone} alt='headphone' />
                <div className='support-team-text'>{t('stepperFormTradeIn.txt3')}</div>
              </div>
            </button>
          </div>
        ) : (
          <>
            <div className='offer-text-heading'>{t('stepperFormTradeIn.txt5')}</div>
            <br />
          </>
        )}

        {offerValue?.Valued ? (
          <>
            <div className='offer-text-heading'>{t('stepperFormTradeIn.txt6')}</div>
            <div className='offer-text-para'>{t('stepperFormTradeIn.txt7')}</div>
          </>
        ) : null}

        {offerValue?.Valued && filteredPointers?.nonYes?.length > 0 ? (
          <>
            <div className='vehicle-heading'>{t('stepperFormTradeIn.txt8')}</div>
            <div className='vehicle-details'>
              <ul className='vehicle-list'>
                {filteredPointers.nonYes.map((pointer, idx) => (
                  <li key={`keypoint_${idx}`}>
                    <img src={CircleArrow} alt='Arrow' />
                    <span>{pointer.keyTxt}</span>
                  </li>
                ))}
              </ul>
            </div>
          </>
        ) : null}

        {filteredPointers?.yes?.length > 0 ? (
          <>
            <div className='questions-heading'>{t('stepperFormTradeIn.txt9')}</div>
            <div className='vehicle-details'>
              <ul className='vehicle-list'>
                {filteredPointers.yes.map((pointer, idx) => (
                  <li key={`qst_key_${idx}`}>
                    <img src={CircleArrow} alt='Arrow' />
                    <span>{pointer.keyTxt}</span>
                  </li>
                ))}
              </ul>
            </div>
          </>
        ) : null}

        <div className='footer-para'>{t('stepperFormTradeIn.txt10')}</div>
      </div>
    </>
  );
};

const ResultStep = React.forwardRef(Result);

export default ResultStep;
